import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";

export const EASE = [0.76, 0, 0.24, 1];

export const MaskedLine = ({ children, delay = 0, className = "", as: Tag = "span" }) => (
    <Tag className={`block overflow-hidden ${className}`}>
        <motion.span
            className="block will-change-transform"
            initial={{ y: "115%" }}
            animate={{ y: "0%" }}
            transition={{ duration: 1.15, delay, ease: EASE }}
        >
            {children}
        </motion.span>
    </Tag>
);

export const Reveal = ({ children, delay = 0, y = 36, className = "", once = true }) => (
    <motion.div
        className={className}
        initial={{ opacity: 0, y }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once, amount: 0.15 }}
        transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
        {children}
    </motion.div>
);

export const ParallaxImage = ({ src, alt, className = "", imgClassName = "", strength = 12 }) => {
    const ref = useRef(null);
    const { scrollYProgress } = useScroll({
        target: ref,
        offset: ["start end", "end start"],
    });
    const y = useTransform(scrollYProgress, [0, 1], [`-${strength}%`, `${strength}%`]);
    return (
        <div ref={ref} className={`relative overflow-hidden ${className}`}>
            <motion.img
                src={src}
                alt={alt}
                loading="lazy"
                style={{ y }}
                className={`absolute inset-0 h-full w-full object-cover scale-[1.25] ${imgClassName}`}
            />
        </div>
    );
};
